import React from 'react';
import { FaRegStar, FaStar, FaStarHalfAlt } from 'react-icons/fa';

const Rating = ({ rating }) => {
  const fullStars = Math.floor(rating); 
  const hasHalfStar = rating - fullStars >= 0.5; 
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0); 

  return (
    <>
      {[...Array(fullStars)].map((_, index) => (
        <FaStar key={index} className='text-xs md:text-sm' color="green"/>
      ))}
      {hasHalfStar && <FaStarHalfAlt className='text-xs md:text-sm' color="green" />}
  
      {[...Array(emptyStars)].map((_, index) => (
        <FaRegStar key={index + fullStars} className='text-xs md:text-sm' color="green"/>
      ))}
    </>
  );
};

export default Rating;
